/**
 * returns a promise that will be resolved after given time in ms
 *
 * @documented
 * @category Function
 * @example
 *
 * 		await sleep(1000) // => one second later execution will continue
 *
 */ const sleep = (ms)=>new Promise((resolve)=>setTimeout(resolve, ms));
export default sleep;
